import { FormattedMessage } from "react-intl";
import { useMoveDrawerContext } from "../inventory-context";
import { SideDrawer } from "../side-drawer";
import { MoveForm } from "./move-form";

export function MoveDrawer() {
  const { isOpen, closeMenu } = useMoveDrawerContext();

  return (
    <SideDrawer
      isOpen={isOpen}
      closeDrawer={closeMenu}
      title={
        <FormattedMessage
          id="inventory.moveDrawer.title"
          defaultMessage="Move"
        />
      }
      drawerData-testId="moveDrawerContainer"
      closeIconData-testId="moveDrawerCloseIcon"
    >
      <MoveForm />
    </SideDrawer>
  );
}
